// src/app/core/guards/offers-policies.guard.ts

import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { PermissionService } from '@core/services/permission.service';
import { guardWithProfile } from './guard.utils';

/**
 * CanMatchFn — gates the entire /offers-policies section.
 *
 * Access is granted if the current user has any of:
 *   - offers_policies.view
 *   - offers_policies.view_mine
 *   - offers_policies.view_branch
 *   - offers_policies.view_all
 *   - offers_policies.create
 * (admin.full_access bypasses all checks via PermissionService.has)
 */
export const offersPoliciesGuard: CanMatchFn = () => {
  const perm = inject(PermissionService);
  return guardWithProfile(() => perm.canViewOffersPolicies(), '/dashboard');
};
